module.exports = __webpack_public_path__ + "img/nbs.dd1268fa.svg";